/* adventskiste.at - Builder: klebende Leisten und Kategorie-Reiter
   (neu 13.09.2026)

   1. VERSATZ. Ankuendigungsleiste und Kopf kleben oben (z-index 101 und
      100). Die Fortschrittsleiste klebte bei top:0, also genau darunter,
      und war beim Scrollen weg - samt Zaehler, Warenwert und "Rest
      ergaenzen". Hier wird gemessen, wo der Kopf endet (--kb-top). Die
      Filterleiste klebt direkt unter der Fortschrittsleiste
      (--kb-sticky-h). --kb-stack-h ist beides zusammen, fuer
      scroll-margin.

   2. REITER. Auf dem Telefon passt nur ein Teil der Kategorien in die
      Breite, und dass man wischen kann, sah man nicht. Ein Verlauf am
      Rand zeigt jetzt, dass es weitergeht; beim ersten Besuch der Sitzung
      ruckt die Leiste einmal kurz an. Die gewaehlte Kategorie rueckt in
      die Mitte.

   3. FILTER-KNOPF (unter 900px). Verfuegbarkeit und Preis liegen hinter
      einem Knopf, damit die Filterleiste eine Zeile hoch bleibt. Ein
      Punkt am Knopf zeigt, dass ein Filter aktiv ist.

   4. ZURUECK AN DEN ANFANG. Wer tief im Raster die Kategorie wechselt,
      stuende sonst mitten in der neuen Liste. Das Raster rueckt dann an
      seinen Anfang unter die Leisten.

   Liest und schreibt nur das DOM; die Filterlogik bleibt im Builder. */
(function () {
  var root = document.getElementById('kiste-builder');
  if (!root) return;

  var sticky = document.getElementById('kb-sticky');
  var toolbar = root.querySelector('.kb-toolbar');
  var tabs = root.querySelector('.kb-toolbar__tabs');
  var grid = document.getElementById('kb-grid');
  var toggle = document.getElementById('kb-filter-toggle');
  var mqMobile = window.matchMedia('(max-width: 899px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Versatz ---------- */

  function stickyHeight(selector) {
    var el = document.querySelector(selector);
    if (!el) return 0;
    var pos = window.getComputedStyle(el).position;
    return pos === 'sticky' || pos === 'fixed' ? el.getBoundingClientRect().height : 0;
  }

  function measure() {
    var top = stickyHeight('.announcement-bar-section') + stickyHeight('.section-header');
    var sh = sticky ? sticky.getBoundingClientRect().height : 0;
    var th = toolbar ? toolbar.getBoundingClientRect().height : 0;
    root.style.setProperty('--kb-top', Math.round(top) + 'px');
    root.style.setProperty('--kb-sticky-h', Math.round(sh) + 'px');
    root.style.setProperty('--kb-stack-h', Math.round(sh + th) + 'px');
  }

  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(measure);
    ['.announcement-bar-section', '.section-header'].forEach(function (s) {
      var el = document.querySelector(s);
      if (el) ro.observe(el);
    });
    if (sticky) ro.observe(sticky);
    if (toolbar) ro.observe(toolbar);
  }
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);

  /* ---------- 2. Reiter ---------- */

  function fade() {
    if (!tabs) return;
    var rest = tabs.scrollWidth - tabs.clientWidth - tabs.scrollLeft;
    tabs.classList.toggle('kb-more-left', tabs.scrollLeft > 4);
    tabs.classList.toggle('kb-more-right', rest > 4);
  }

  function centerPill(pill) {
    if (!tabs || !pill) return;
    var t = tabs.getBoundingClientRect();
    var p = pill.getBoundingClientRect();
    var left = tabs.scrollLeft + (p.left - t.left) - (t.width - p.width) / 2;
    tabs.scrollTo({ left: Math.max(0, left), behavior: reduce ? 'auto' : 'smooth' });
  }

  /* Einmal pro Sitzung kurz anruckeln - nur wenn es ueberhaupt etwas
     zu wischen gibt und niemand schon selbst gewischt hat. */
  function peek() {
    if (reduce || !tabs || !tabs.classList.contains('kb-more-right')) return;
    try {
      if (sessionStorage.getItem('kb_tabs_peek')) return;
      sessionStorage.setItem('kb_tabs_peek', '1');
    } catch (e) { /* privater Modus: dann eben jedes Mal */ }
    setTimeout(function () {
      if (tabs.scrollLeft > 4) return;
      tabs.scrollTo({ left: 64, behavior: 'smooth' });
      setTimeout(function () {
        tabs.scrollTo({ left: 0, behavior: 'smooth' });
      }, 700);
    }, 1000);
  }

  if (tabs) {
    tabs.addEventListener('scroll', fade, { passive: true });
    window.addEventListener('resize', fade);
  }

  /* ---------- 3. Filter-Knopf ---------- */

  /* "Nur verfuegbare" ist seit 13.09.2026 von Anfang an an. Der Punkt
     meldet deshalb nur, was vom Ausgangszustand abweicht - sonst
     leuchtete er immer und saehe nach etwas aus, das man selbst
     eingestellt hat. */
  function filtersActive() {
    var sold = document.getElementById('kb-hide-sold');
    var price = root.querySelector('.kb-price-btn.active');
    /* Die Suche zaehlt mit (15.09.2026): sie steht auf dem Telefon hinter
       demselben Knopf und ist der Filter, den man am ehesten vergisst. */
    var search = document.getElementById('kb-search-input');
    return !!(sold && !sold.checked)
      || !!(price && price.getAttribute('data-max') !== '999')
      || !!(search && search.value.trim());
  }

  /* Der Builder ruft das, wenn sich die Suche aendert. */
  window.kbSyncFilterDot = function () { syncDot(); };

  function syncDot() {
    if (!toggle) return;
    var on = filtersActive();
    toggle.classList.toggle('is-active', on);
    toggle.setAttribute('aria-label', on ? 'Filter, aktiv' : 'Filter');
    var dot = toggle.querySelector('.kb-filter-dot');
    if (dot) dot.hidden = !on;
  }

  function isOpen() {
    return !!toolbar && toolbar.classList.contains('is-filters-open');
  }

  function setOpen(open) {
    if (!toolbar || !toggle) return;
    toolbar.classList.toggle('is-filters-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  if (toggle) {
    toggle.addEventListener('click', function () { setOpen(!isOpen()); });
  }

  document.addEventListener('click', function (e) {
    if (isOpen() && toolbar && !toolbar.contains(e.target)) setOpen(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) {
      setOpen(false);
      if (toggle) toggle.focus();
    }
  });

  var onMq = function () { if (!mqMobile.matches) setOpen(false); };
  if (mqMobile.addEventListener) mqMobile.addEventListener('change', onMq);
  else if (mqMobile.addListener) mqMobile.addListener(onMq);

  /* ---------- 4. Zurueck an den Anfang des Rasters ---------- */

  function backToGrid() {
    if (!grid || !toolbar) return;
    var stackBottom = toolbar.getBoundingClientRect().bottom;
    var gridTop = grid.getBoundingClientRect().top;
    if (gridTop < stackBottom - 2) {
      window.scrollBy({ top: gridTop - stackBottom, behavior: reduce ? 'auto' : 'smooth' });
    }
  }

  /* Delegiert am Builder: laeuft nach den Klick-Handlern des Builders,
     die Karten sind also schon gefiltert, wenn hier gemessen wird. */
  root.addEventListener('click', function (e) {
    var pill = e.target.closest('.kb-pill');
    if (pill) {
      centerPill(pill);
      backToGrid();
      return;
    }
    if (e.target.closest('.kb-price-btn')) {
      syncDot();
      backToGrid();
      return;
    }
    if (e.target.closest('.kb-reset-filters')) syncDot();
  });

  root.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'kb-hide-sold') {
      syncDot();
      backToGrid();
    }
  });

  /* ---------- Start ---------- */

  measure();
  fade();
  syncDot();
  peek();
})();
